export default {
  title: 'Partners',
  search_placeholder: 'Search partner...',
  buttons: {
    default_price_list: 'Default price list',
    create_partner: 'Create partner',
  },
  columns: {
    name: 'Name',
    restaurants: 'Restaurants',
    shop_domain: 'Shop domain',
    status: 'Status',
    earning_enabled: 'Earning enabled',
  },
  statuses: {
    invited: 'Invited',
    active: 'Active',
    suspended: 'Suspended',
  },
  actions: {
    edit: 'Edit',
    view_billing: 'View billing',
    view_as_partner: 'View as partner',
    suspend: 'Suspend',
    unsuspend: 'Unsuspend',
  },
  suspension: {
    suspend_title: 'Suspend this partner?',
    suspend_description:
      'All of the partner’s team members will be deactivated and their sessions revoked. Their restaurants stay live.',
    unsuspend_title: 'Unsuspend this partner?',
    unsuspend_description: 'All of the partner’s team members will be reactivated and can log in again.',
  },
  toasts: {
    load_error: 'Could not load the partners.',
    suspended: 'The partner has been suspended.',
    unsuspended: 'The partner has been unsuspended.',
    suspension_error: 'Could not change the partner status.',
    view_as_error: 'Could not open the partner dashboard.',
  },
};
